import React from "react";

/**
 * Real cup mascot using brand asset PNG.
 * variant: "beef" | "chicken"
 * state: "idle" | "draw" | "ko" | "win"
 */
export const NoodleCup = ({ variant = "beef", state = "idle", size = 320, testid }) => {
  const src = variant === "beef" ? "/brand/cup-beef.png" : "/brand/cup-chicken.png";
  const facingLeft = variant === "chicken";

  const stateClass =
    state === "ko"
      ? facingLeft ? "ko-anim-left" : "ko-anim-right"
      : state === "draw" ? "shake-anim"
      : state === "win" ? "win-anim"
      : "idle-anim";

  return (
    <div
      data-testid={testid}
      className={stateClass}
      style={{ display: "inline-block", height: size, position: "relative" }}
    >
      <img
        src={src}
        alt={variant === "beef" ? "Smokehouse BBQ Beef cup" : "Smokehouse BBQ Chicken cup"}
        style={{
          height: size,
          width: "auto",
          display: "block",
          filter: "drop-shadow(6px 8px 0 rgba(58,29,4,0.45))",
        }}
        draggable={false}
      />
    </div>
  );
};

export default NoodleCup;
